module.exports = __webpack_public_path__ + "68e836607f21518526de6155f19c0992.ttf";